<template>
  <section class="package-hotel-item">
    <ItemDescription
      :itemid="item.id"
      :name="item.package_display_name"
      :price="item.price_decorated"
      :eventname="item.event_display_name"
      :package-id="item.package_id"
      candelete="true"
    />

    <div
      v-if="ers"
      class="errors"
    >
      <span>{{ ers }}</span>
      <span
        class="delete"
        @click="ers = null"
      />
    </div>

    <ItemQty
      :quantity="item.quantity"
      :maxqty="maxPackageQty"
      :updating="updating"
      candelete="true"
      @update-qty="updatePackage"
      @delete-item="deleteItem"
    />

    <ItemDescription
      :itemid="item.id"
      :name="hotel_display_name"
      price=""
      eventname=""
      candelete="false"
    />

    <ItemQty
      :quantity="item.room_quantity"
      :maxqty="maxHotelQty"
      :updating="updating"
      candelete="false"
      @update-qty="updateHotel"
    />
  </section>
</template>

<script>
import ItemDescription from './item_description'
import ItemQty from './item_quantity'
import PackageAndHotelJs from '../package_and_hotel_item_shared_methods'

export default Object.assign({}, PackageAndHotelJs, {
  components: {
    ItemDescription,
    ItemQty
  }
})
</script>
